module.exports = __webpack_public_path__ + "static/media/Picture2.0a64c488.jpg";